import { createSlice } from "@reduxjs/toolkit";
import { fetchAgents, fetchAgentsStats, forceAwayAgent, fetchAgentsWithStats } from "./teamActivityAPI";
import { toast } from 'react-toastify';

export const initialState = {
    agents: {
        loading: false,
        error: null,
        data: [],
        dataUnfiltered: []
    }
};

export const teamActivitySlice = createSlice({
    name: "team-activity",
    initialState: initialState,
    reducers: {
        setOnlineOfflineStatus: (state, action) => {
            const index = state.agents.data.findIndex(x => x.email == action.payload.email);
            if (index > -1) {
                state.agents.data[index].isOnline = action.payload.value;
                state.agents.data[index].agentStatus = action.payload.agentStatus;
            }
        }
    },
    extraReducers: {
        [fetchAgents.pending]: (state) => {
            state.agents.loading = true;
        },
        [fetchAgents.rejected]: (state, { meta, error }) => {
            state.agents.loading = false;
            state.agents.data = [];
            state.agents.error = error;
        },
        [fetchAgents.fulfilled]: (state, { meta, payload: { data } }) => {
            state.agents.loading = false;
            state.agents.error = '';
            state.agents.data = data;
            state.agents.data.forEach((element) => {
                element.availableHours = 0;
                element.breakHours = 0;
                element.chatCount = 0;
                element.avgRatingValue = 0;
                element.avgResponseTime = 0;
                element.lastLoginDate = null;
                element.lastLogoutDate = null;
            });
        },
        [forceAwayAgent.pending]: (state) => {
        },
        [forceAwayAgent.rejected]: (state, { meta, error }) => {
            let agent = state.agents.data.find(x => x.id === meta.arg);
            if (agent) {
                toast.error(`${agent.email} ' : Unable to force away...!`);
            }
        },
        [forceAwayAgent.fulfilled]: (state, { meta, payload: { data } }) => {
            let agent = state.agents.data.find(x => x.id === meta.arg);
            if (agent) {
                agent.isOnline = false;
                toast.success(`${agent.email} ' is force away...!`);
            }
        },
        [fetchAgentsStats.pending]: (state) => {
        },
        [fetchAgentsStats.rejected]: (state, { meta, error }) => {
            toast.error(`'Unable to get agents stats...!`);
        },
        [fetchAgentsStats.fulfilled]: (state, { meta, payload: { data } }) => {
            data.forEach((agentStat) => {
                let agent = state.agents.data.find(a => a.id == agentStat.id);
                if (agent) {
                    agent.availableHours = agentStat.availableHours;
                    agent.breakHours = agentStat.breakHours;
                    agent.chatCount = agentStat.chatCount;
                    agent.avgRatingValue = agentStat.avgRatingValue;
                    agent.avgResponseTime = agentStat.avgResponseTime;
                    agent.lastLoginDate = agentStat.lastLoginDate;
                    agent.lastLogoutDate = agentStat.lastLogoutTime;
                }

            });
        },
        [fetchAgentsWithStats.pending]: (state) => {
            state.agents.loading = true;
        },
        [fetchAgentsWithStats.rejected]: (state, { meta, error }) => {
            state.agents.loading = false;
            state.agents.data = state.agents.dataUnfiltered = [];
            state.agents.error = error;
        },
        [fetchAgentsWithStats.fulfilled]: (state, { meta, payload }) => {
            state.agents.loading = false;
            state.agents.error = '';
            // Get data of both APIs and merge them
            const agents = payload.length > 0 ? payload[0].data : [];
            const agentsStats = payload.length > 1 ? payload[1].data : [];
            agentsStats.forEach((agentStat) => {
              const agent = agents.find((a) => a.id === agentStat.id);
              if (agent) {
                for (const key in agentStat) {
                  agent[key] = agentStat[key];
                }
                // agent.availableHours = agentStat.availableHours;
                // agent.breakHours = agentStat.breakHours;
                // agent.chatCount = agentStat.chatCount;
                // agent.avgRatingValue = agentStat.avgRatingValue;
                // agent.avgResponseTime = agentStat.avgResponseTime;
                // agent.lastLoginDate = agentStat.lastLoginDate;
                agent.lastLogoutDate = agentStat.lastLogoutTime;
              }
            });

            // Finally set data in stats
            state.agents.data = agents;

            // Set dataUnfiltered only when increase in data length
            if (agents.length > state.agents.dataUnfiltered.length) {
              state.agents.dataUnfiltered = agents;
            }
        },
    },
});
export const { setOnlineOfflineStatus } = teamActivitySlice.actions;

export default teamActivitySlice.reducer;